module.exports = __webpack_public_path__ + "img/tks_qsp.7ef77609.png";